// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const LenisProvider = registerClientReference(
    function() { throw new Error("Attempted to call LenisProvider() from the server but LenisProvider is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/providers/LenisProvider.tsx",
    "LenisProvider",
);
export const useLenis = registerClientReference(
    function() { throw new Error("Attempted to call useLenis() from the server but useLenis is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/components/providers/LenisProvider.tsx",
    "useLenis",
);
